import { createElement } from "react";
import iconSet from "./../../assets/icons/selection.json";
import PropTypes from "prop-types";

// Usage of svg icons after converting using the icomoon JSON,
// Apply the following syntax
// <Icon icon="ic_copy" size={20} className={classes.test} />

const style = {
  display: "inline-block",
  stroke: "currentColor",
  fill: "currentColor",
};

const Icon = ({ icon, size, disableFill, removeInlineStyle, ...props }) => {
  if (!iconSet || !icon) {
    // console.warn('The "iconSet" and "icon" props are required.');
    return null;
  }

  const currentIcon = iconSet.icons.find(
    (item) => item.properties.name === icon
  );

  if (!currentIcon) {
    // console.warn(`"${icon}" icon not found.`);
    return null;
  }

  if (size) {
    style.width = size;
    style.height = size;
  }

  if (props.native) {
    style.display = "flex";
    style.flexDirection = "row";
    style.flexWrap = "wrap";
  }

  props.style = {
    ...(removeInlineStyle ? {} : style),
    ...(props.style || {}),
  };

  const { width = "1024" } = currentIcon.icon;

  props.viewBox = `0 0 ${width} 1024`;

  const paths = currentIcon.icon.paths.map((path, index) => {
    const pathProps = {
      d: path,
      key: icon + index,
      ...(!disableFill ? currentIcon.icon.attrs[index] : {}),
    };

    return createElement("path", pathProps);
  });

  return createElement("svg", props, paths);
};

const IconList = () => {
  if (iconSet && Array.isArray(iconSet.icons)) {
    return iconSet.icons.map((icon) => icon.properties.name);
  }
  return null;
};

Icon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.number,
  disableFill: PropTypes.any,
  removeInlineStyle: PropTypes.any,
  native: PropTypes.any,
  style: PropTypes.object,
};

export { Icon, IconList };
